import SafeltoLogo from '../../assets/icons/SafeltoLogo'
import { Link } from 'react-router-dom'

interface ResieaseLogoProps {
  theme: 'dark' | 'light'
  link?: string
  top?: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
  displayText?: boolean
}

type ResieaseLogoSizeConfig = {
  fontSize: string
  imageSize: string
}

const getSize = (size?: ResieaseLogoProps['size']): ResieaseLogoSizeConfig => {
  switch (size) {
    case 'xs':
      return {
        fontSize: 'md',
        imageSize: '7',
      }
    case 'sm':
      return {
        fontSize: 'lg',
        imageSize: '8',
      }
    case 'md':
      return {
        fontSize: '2xl',
        imageSize: '9',
      }
    case 'lg':
      return {
        fontSize: '2xl',
        imageSize: '10',
      }
    default:
      return {
        fontSize: '3xl',
        imageSize: '12',
      }
  }
}

const ResieaseLogo = ({
  theme,
  link = '#',
  top,
  size,
  displayText = true,
}: ResieaseLogoProps) => {
  const sizeConfig = getSize(size)
  return (
    <Link to={link} className="text-decoration-none hover:text-decoration-none">
      <div className={`mt-${top} flex items-center`}>
        {/* <SafeltoLogo
          className={`w-${sizeConfig.imageSize} min-w-${sizeConfig.imageSize}`}
        /> */}
        <SafeltoLogo />
        {displayText ? (
          <span
            className={`text-${sizeConfig.fontSize} ml-2 text-${
              theme === 'light' ? 'black' : 'white'
            }`}
          ></span>
        ) : null}
      </div>
    </Link>
  )
}

export default ResieaseLogo
